import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useUser, useDancesLeft } from '@state/uses/users'
import { setDanceOnAddProcess } from '@state/actions/dances'
import { getCurrentUser } from '@state/actions/users'
import DancesTable from '@components/Dances/DancesTable'
import ActionButton from '@components/Dances/ActionButton'
import { creditCardIcon, plusIcon } from '@assets/images'
import { MainPageWrapper } from '@appearance/styled'
import api from '@services/api'
import i18n from '@localization/i18n'
import urlUtils from '@services/urlUtils'

const yearToPay = new Date().getFullYear()

export default () => {
    const user = useUser()
    const [formattedUser, setFormattedUser] = useState()

    useEffect(() => {
        if (user) {
            getFormatedUser(user.user_id)
        }
    }, [user])

    const getFormatedUser = (userId) => {
        api.getUserById(userId).subscribe(
            (res) => {
                console.log('getFormatedUser res', res.data)
                setFormattedUser(res.data)
            },
            (error) => {
                console.log('getFormatedUser error', error)
            }
        )
    }
    const history = useHistory()
    const dispatch = useDispatch()
    const dancesLeft = useDancesLeft()
    const [showAddDanceButton, setShowAddDanceButton] = useState(false)

    const goToPayment = () => {
        alert('Payment page is under construction')
    }

    const goToAddDance = () => {
        dispatch(setDanceOnAddProcess(null))
        const originalPage = window.location.search
            ?.split('page=')[1]
            ?.split('&')[0]
        urlUtils.setQueryParams({ originalPage })
        localStorage.setItem(
            '@markidim:filter_state',
            window.location.search?.slice(1)
        )
        history.push({
            pathname: '/dance',
        })
    }

    useEffect(() => {
        dispatch(getCurrentUser(() => setShowAddDanceButton(true)))
    }, [])
    return (
        <MainPageWrapper>
            <HeaderBtnsContainer>
                {user && showAddDanceButton && (
                    <ActionButton
                        label={i18n.t('buttons.add_new_dance')}
                        onClick={goToAddDance}
                        bgColor={'rgb(83,71,103)'}
                        icon={plusIcon}
                        smallText={
                            i18n.locale === 'en'
                                ? (dancesLeft > 0 ? dancesLeft : 0) +
                                  ' ' +
                                  i18n.t('buttons.songs') +
                                  ' ' +
                                  i18n.t('buttons.remaining')
                                : i18n.t('buttons.remaining') +
                                  ' ' +
                                  (dancesLeft > 0 ? dancesLeft : 0) +
                                  ' ' +
                                  i18n.t('buttons.songs')
                        }
                        disabled={dancesLeft < 1 || formattedUser?.is_suspended}
                    />
                )}
                <ActionButton
                    label={i18n.t('buttons.pay_membership')}
                    onClick={goToPayment}
                    bgColor={'#192F3A'}
                    icon={creditCardIcon}
                    smallText={i18n.t('buttons.to_year') + ' ' + yearToPay}
                />
            </HeaderBtnsContainer>
            <DancesTable />
        </MainPageWrapper>
    )
}

const HeaderBtnsContainer = styled.div`
    width: 100%;
    display: flex;
    padding: 20px 20px 0px;
    justify-content: flex-end;
`
